import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, PlayCircle, ShieldCheck } from "lucide-react";
import YoutubeVideoLightbox from "../../components/YoutubeVideoLightbox";
import PageSeo from "../../components/PageSeo";
import { DEFAULT_SITE_DESCRIPTION } from "../../lib/pageSeo";
import { JOBUWIN_INTRO_VIDEO_ID } from "../../lib/youtubeVideos";

const HOW_IT_WORKS_YOUTUBE_ID = JOBUWIN_INTRO_VIDEO_ID;

export default function old1_HoldingPage() {
  const [showHowItWorksVideo, setShowHowItWorksVideo] = useState(false);
  useEffect(() => {
    const cls = "holding-page-active";
    document.documentElement.classList.add(cls);
    document.body.classList.add(cls);
    return () => {
      document.documentElement.classList.remove(cls);
      document.body.classList.remove(cls);
    };
  }, []);

  return (
    <main className="holding-page jw-public-page jw-holding-page">
      <PageSeo
        title="Genuine jobs. Real people."
        description={DEFAULT_SITE_DESCRIPTION}
        path="/"
        schemaType="website"
      />
      <section className="jw-holding-shell">
        <div className="jw-holding-panel">
          <span className="jw-public-chip">
            <ShieldCheck className="jw-public-icon" aria-hidden="true" />
            JOBUWIN preview
          </span>
          <div className="holding-brand jw-holding-brand">
            <img
              src="/jobuwin-icon.svg"
              alt=""
              className="holding-icon jw-holding-icon"
              aria-hidden
            />
            <img
              src="/jobuwin-tagline.svg"
              alt="Jobuwin"
              className="holding-logo jw-holding-logo"
            />
          </div>
          <h1 className="jw-holding-title">Genuine jobs. Real people.</h1>
          <p className="jw-holding-copy">
            A jobs searching and hiring platform that connects genuine job opportunities to real people.
            No fakes, no AI. Just genuine human interactions.
          </p>
          <div className="jw-public-action-row">
            <Link className="jw-public-button jw-public-button--primary" to="/old1/home">
              Explore JOBUWIN
              <ArrowRight className="jw-public-icon" aria-hidden="true" />
            </Link>
            <a
              className="jw-public-button jw-public-button--linkedin"
              href="https://www.linkedin.com/company/jobuwin/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="jw-linkedin-mark" aria-hidden="true">in</span>
              Follow on LinkedIn
            </a>
            <a className="jw-public-button jw-public-button--outline" href="mailto:hello@jobuwin.com">
              Say hello
            </a>
          </div>
          <div className="jw-holding-watch-row">
            <button
              type="button"
              className="jw-public-button jw-public-button--secondary jw-holding-watch-cta"
              onClick={() => setShowHowItWorksVideo(true)}
            >
              <PlayCircle className="jw-public-icon" aria-hidden="true" />
              See our intro video
            </button>
          </div>
        </div>

        <aside className="jw-holding-card" aria-label="JOBUWIN promise">
          <h2>Built around trust before scale.</h2>
          <p className="jw-holding-copy">
            We are shaping JOBUWIN around better matches, clearer proof, and a more human hiring experience.
          </p>
          <div className="jw-holding-list">
            <span><CheckCircle2 className="jw-public-icon" aria-hidden="true" /> Applicants show real experience and expertise</span>
            <span><CheckCircle2 className="jw-public-icon" aria-hidden="true" /> Hiring teams focus on genuine matches with real experience and no noise</span>
            <span><CheckCircle2 className="jw-public-icon" aria-hidden="true" /> A platform designed around clarity, authenticity, and human connection</span>
          </div>
        </aside>
      </section>

      <YoutubeVideoLightbox
        open={showHowItWorksVideo}
        onClose={() => setShowHowItWorksVideo(false)}
        videoId={HOW_IT_WORKS_YOUTUBE_ID}
        title="See how JOBUWIN works"
      />
    </main>
  );
}
